import { ComponentProps } from 'react';

import MediaLibraryProviderBag from '~modules/media-library/context/MediaLibraryProviderBag';
import { MediaLibrary } from '~modules/media-library/view/MediaLibrary';

export default function MediaLibraryController(props: Resolve<ComponentProps<typeof MediaLibrary>>) {
  return (
    <MediaLibraryProviderBag realm={props.realm}>
      <MediaLibrary {...props} />
    </MediaLibraryProviderBag>
  );
}
